package org.zq.flvtomp4.queue

import org.zq.flvtomp4.converter.ConvertMode

data class ConvertTask(
    val id: String,
    val inputPath: String,
    val fileName: String,
    val outputPath: String,
    val status: TaskStatus = TaskStatus.WAITING,
    val progress: Float = 0f,
    val speed: String? = null,
    val durationMs: Long = 0L,
    val processedMs: Long = 0L,
    val errorMessage: String? = null,
    val logs: List<String> = emptyList(),
    val resolvedMode: ConvertMode? = null,
)
